import React from 'react';
import { Typography } from '@mui/material';

const PageHeader = ({ title, align = 'center', sx = {} }) => (
  <Typography variant="h3" align={align} sx={{ fontWeight: 700, mb: 2, ...sx }}>
    {title}
  </Typography>
);

export default PageHeader;
